import { useEffect, useRef, useState } from "react";

// Counts up once on entry, then never again. Reduced-motion → static number.
export default function Counter({ to, duration = 1400, suffix = "", className = "" }) {
  const ref = useRef(null);
  const [v, setV] = useState(0);
  const done = useRef(false);

  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) {
      setV(to);
      return;
    }
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([e]) => {
        if (!e.isIntersecting || done.current) return;
        done.current = true;
        const start = performance.now();
        const loop = (now) => {
          const t = Math.min(1, (now - start) / duration);
          const eased = 1 - Math.pow(1 - t, 3);
          setV(Math.round(to * eased));
          if (t < 1) requestAnimationFrame(loop);
        };
        requestAnimationFrame(loop);
      },
      { threshold: 0.4 },
    );
    io.observe(el);
    return () => io.disconnect();
  }, [to, duration]);

  return (
    <span ref={ref} className={className} data-testid={`counter-${to}`}>
      {v}
      {suffix}
    </span>
  );
}
